import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appConfigActions, getAppConfig } from '../store';
import { extractErrorMessage } from '../utils/error.utils';
import axios from 'axios';
import { APP_CONFIG } from '../config/api';

const useAppConfig = () => {
    const config = useSelector(getAppConfig);
    const dispatch = useDispatch();

    const fetchAppConfig = async () => {
        try {
            const response = await axios.get(APP_CONFIG);
            dispatch(appConfigActions.set(response.data));
        } catch (err: any) {
            console.log('failed to get app-config:', extractErrorMessage(err));
        }
    };

    useEffect(() => {
        fetchAppConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return config;
};

export default useAppConfig;
